"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
var _sharePanel = _interopRequireDefault(require("../share-panel"));
var _image = _interopRequireDefault(require("../image"));
var _icon = _interopRequireDefault(require("../icon"));
var _actionsheet = _interopRequireDefault(require("../actionsheet"));
var _utils = require("../utils");
var _platforms = _interopRequireDefault(require("./platforms"));
var _api = require("./api");
var _use = (0, _utils.use)('platform-share-panel'),
  sfc = _use[0],
  bem = _use[1];
var _native;
if (!_utils.isServer) {
  _native = require('@zz-common/native-adapter').default; // eslint-disable-line global-require
}
var _default = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', [_c('div', {
      on: {
        "click": _vm.onHandleClick
      }
    }, [_vm._t("btnMore", [_c('z-icon', {
      attrs: {
        "optimizeClickArea": true,
        "class-prefix": "zziconfont-6",
        "name": "more",
        "size": "20px"
      }
    })])], 2), _c('z-actionsheet', {
      class: {
        'home-tab-share': _vm.isShowHomeShare && !_vm.isiPhoneX
      },
      attrs: {
        "getContainer": _vm.getContainerDom,
        "lockScroll": false,
        "title": _vm.sheetTitleInfo,
        "cancel-text": "取消"
      },
      on: {
        "cancel": _vm.cancelClick
      },
      model: {
        value: _vm.show,
        callback: function callback($$v) {
          _vm.show = $$v;
        },
        expression: "show"
      }
    }, [_c('div', {
      class: _vm.bem()
    }, [_vm.platform && _vm.platform.length ? _c('div', {
      class: _vm.bem('platforms')
    }, [_c('div', {
      staticClass: "horizontal",
      style: {
        paddingBottom: _vm.common && _vm.common.length || _vm.action && _vm.action.length ? 20 + 'px' : 0 + 'px'
      }
    }, [_c('ul', {
      staticClass: "list-wrapper"
    }, _vm._l(_vm.platform, function (item, index) {
      return _c('li', {
        key: item.value,
        class: _vm.bem('item'),
        on: {
          "click": function click() {
            return _vm.onPlatformClick(item, index);
          }
        }
      }, [_c('div', {
        class: _vm.bem('item-wrapper')
      }, [_c('z-image', {
        class: _vm.bem('item-wrapper-logo'),
        attrs: {
          "fit": "cover",
          "round": "",
          "src": item.logo
        }
      }, [_c('div', {
        attrs: {
          "slot": "loading"
        },
        slot: "loading"
      })]), _c('span', {
        class: _vm.bem('item-wrapper-title')
      }, [_vm._v(_vm._s(item.title))])], 1)]);
    }), 0)])]) : _vm._e(), _vm.platform && _vm.platform.length && (_vm.common && _vm.common.length || _vm.action && _vm.action.length) ? _c('div', {
      class: _vm.bem('line-wrapper')
    }, [_c('div', {
      class: _vm.bem('line-wrapper-line')
    })]) : _vm._e(), _vm.common && _vm.common.length ? _c('div', {
      class: _vm.bem('commons')
    }, [_c('div', {
      staticClass: "horizontal"
    }, [_c('ul', {
      staticClass: "list-wrapper"
    }, _vm._l(_vm.common, function (item, index) {
      return _c('li', {
        key: item.title,
        class: _vm.bem('item'),
        on: {
          "click": function click() {
            return _vm.onCommonsClick(item, index);
          }
        }
      }, [_c('div', {
        class: _vm.bem('item-wrapper')
      }, [item.badge && +item.badge !== 0 ? _c('div', {
        class: _vm.bem('item-wrapper-counts')
      }, [_vm._v(_vm._s(item.badge > 99 ? '99+' : item.badge))]) : _vm._e(), +_vm.allUnreadCount !== 0 && item.type === 'message' ? _c('div', {
        class: _vm.bem('item-wrapper-counts')
      }, [_vm._v("\n                      " + _vm._s(_vm.allUnreadCount > 99 ? '99+' : _vm.allUnreadCount) + "\n                    ")]) : _vm._e(), _c('z-image', {
        class: _vm.bem('item-wrapper-logo'),
        attrs: {
          "fit": "cover",
          "round": "",
          "src": item.icon
        }
      }, [_c('div', {
        attrs: {
          "slot": "loading"
        },
        slot: "loading"
      })]), _c('span', {
        class: _vm.bem('item-wrapper-title')
      }, [_vm._v(_vm._s(item.title))])], 1)]);
    }), 0)])]) : _vm._e(), _vm.action && _vm.action.length ? _c('div', {
      class: _vm.bem('actions')
    }, [_c('div', {
      staticClass: "horizontal"
    }, [_c('ul', {
      staticClass: "list-wrapper"
    }, _vm._l(_vm.action, function (item, index) {
      return _c('li', {
        key: item.value,
        class: _vm.bem('item'),
        on: {
          "click": function click() {
            return _vm.onCationClick(item, index);
          }
        }
      }, [_c('div', {
        class: _vm.bem('item-wrapper')
      }, [_c('z-image', {
        class: _vm.bem('item-wrapper-logo'),
        attrs: {
          "fit": "cover",
          "round": "",
          "src": item.logo
        }
      }, [_c('div', {
        attrs: {
          "slot": "loading"
        },
        slot: "loading"
      })]), _c('span', {
        class: _vm.bem('item-wrapper-title')
      }, [_vm._v(_vm._s(item.title))])], 1)]);
    }), 0)])]) : _vm._e()])])], 1);
  },
  name: 'z-platform-share-panel',
  components: {
    'z-share-panel': _sharePanel.default,
    'z-image': _image.default,
    'z-icon': _icon.default,
    'z-actionsheet': _actionsheet.default
  },
  props: {
    platforms: {
      type: [Object, Boolean]
    },
    commons: {
      type: Array
    },
    isHome: {
      type: Boolean
    },
    actions: {
      type: Array
    },
    sheetTitle: {
      type: String
    },
    getContainer: {
      type: [String, Function]
    }
  },
  data: function data() {
    return {
      bem: bem,
      sfc: sfc,
      show: false,
      sheetTitleInfo: this.$attrs.sheetTitle,
      getContainerDom: this.$props.getContainer,
      contacts: this.$attrs.contacts,
      platform: (0, _utils.handlePlatform)(this.$props.platforms, [].concat(_platforms.default)),
      common: this.$props.commons || [],
      action: this.$attrs.actions || [],
      copyText: '',
      allUnreadCount: 0,
      isiPhoneX: _utils.isiPhoneX
    };
  },
  computed: {
    shouldShowMoreContact: function shouldShowMoreContact() {
      return this.contacts && this.contacts.length > 5;
    },
    isShowHomeShare: function isShowHomeShare() {
      console.log(this.isHome);
      return this.isHome;
    }
  },
  watch: {
    platforms: {
      handler: function handler(v) {
        this.platform = (0, _utils.handlePlatform)(v, [].concat(_platforms.default));
      },
      deep: true,
      immediate: true
    },
    commons: {
      handler: function handler(v) {
        this.common = v;
      },
      deep: true,
      immediate: true
    },
    actions: {
      handler: function handler(v) {
        this.action = v;
      },
      deep: true,
      immediate: true
    },
    sheetTitle: {
      handler: function handler(v) {
        this.sheetTitleInfo = v;
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getMoreitemcomponenth5: function getMoreitemcomponenth5() {
      var _this = this;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var params, res;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              params = {
                pageId: _this.$attrs.pageId || 'V4961',
                extend: JSON.stringify(_this.$attrs.extend)
              };
              _native.wrap('getAllUnreadCount')(function (res) {
                if (+res.code === 0) {
                  _this.allUnreadCount = res.unreadCount;
                }
              });
              _context.next = 4;
              return (0, _api.apiGetmoreitemcomponenth5)(params);
            case 4:
              res = _context.sent;
              _this.common = _this.$props.commons || (res === null || res === void 0 ? void 0 : res.itemList) || [];
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    onContactsClick: function onContactsClick(item, index) {
      this.sendLego(item, index);
      this.show = false;
      this.$emit('contact-select', item);
    },
    onShowMoreContact: function onShowMoreContact(item, index) {
      this.sendLego(item, index);
      this.show = false;
      this.$emit('show-more-contact');
    },
    onPlatformClick: function onPlatformClick(item, index) {
      var _this2 = this;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var el;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.sendLego(item, index);
              if (item.scene && item.type && item.value !== 'copy') {
                _native.wrap('baseShare')({
                  data: item.data,
                  scene: item.scene,
                  type: item.type
                }, function (res) {
                  console.log(res);
                  _this2.$emit('platform-select', item, res);
                });
              } else if (item.value === 'copy') {
                if (_this2.copyText) {
                  el = document.createElement('input'); // 给input元素赋值需要复制的文本
                  el.setAttribute('value', _this2.copyText);
                  // 将input元素插入页面
                  document.body.appendChild(el);
                  // 选中input元素的文本
                  el.select(el);
                  // 复制内容到剪贴板
                  if (document.execCommand('copy')) {
                    document.execCommand('copy');
                  } else {
                    el.setSelectionRange(0, el.value.length);
                    document.execCommand('Copy');
                  }
                  // 删除input元素
                  document.body.removeChild(el);
                  _this2.$toast('复制成功');
                } else {
                  _this2.$toast('暂无链接');
                }
                _this2.show = false;
                _this2.$emit('platform-select', item);
              } else {
                _this2.show = false;
                _this2.$emit('platform-select', item);
              }
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    onCommonsClick: function onCommonsClick(item, index) {
      this.sendLego(item, index);
      this.show = false;
      this.$emit('commons-select', item);
      if (item.jumpUrl) {
        _native.skipToUrl({
          targetUrl: item.jumpUrl
        });
      }
    },
    onCationClick: function onCationClick(item, index) {
      this.sendLego(item, index);
      this.show = false;
      this.$emit('action-select', item);
      if (item.jumpUrl) {
        _native.skipToUrl({
          targetUrl: item.jumpUrl
        });
      }
    },
    onHandleClick: function onHandleClick() {
      var _this3 = this;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var item, respData;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this3.show = true;
              window.lego.send({
                pagetype: 'PopupShow',
                actiontype: _this3.$attrs.pageId,
                backup: {
                  popupname: '右上角更多弹窗',
                  sectionId: '745'
                }
              });
              item = _this3.platform.filter(function (item) {
                return item.value === 'copy';
              });
              _this3.getMoreitemcomponenth5();
              if (!(item.length && item[0].jumpUrl)) {
                _context3.next = 9;
                break;
              }
              _context3.next = 7;
              return (0, _api.getmsharecommon)({
                longurl: item[0].jumpUrl
              });
            case 7:
              respData = _context3.sent;
              _this3.copyText = respData === null || respData === void 0 ? void 0 : respData.shareWording;
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    sendLego: function sendLego(item, index) {
      window.lego.send({
        pagetype: 'PopupClick',
        actiontype: this.$attrs.pageId,
        backup: {
          popupname: '右上角更多弹窗',
          sectionId: '745',
          sortName: item.title,
          sortId: index
        }
      });
    },
    cancelClick: function cancelClick() {
      window.lego.send({
        pagetype: 'clickClose',
        actiontype: this.$attrs.pageId,
        backup: {
          popupname: '右上角更多弹窗',
          sectionId: '745'
        }
      });
    }
  }

  // props: {},
};
exports.default = _default;